const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export async function requestTalk(text, image = "host") {
  try {
    const res = await fetch(`${API}/host/talk`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ text, image }),
    });
    if (!res.ok) return null;
    return await res.json();
  } catch {
    return null;
  }
}

export async function pollTalk(talkId, maxMs = 360000) {
  const t0 = Date.now();
  while (Date.now() - t0 < maxMs) {
    await new Promise((r) => setTimeout(r, 5000));
    try {
      const res = await fetch(`${API}/host/talk/${talkId}`);
      if (!res.ok) continue;
      const d = await res.json();
      if (d.video_url) return d.video_url;
      if (d.status === "error" || d.status === "rejected") return null;
    } catch {}
  }
  return null;
}
